import React from 'react';
import { connect } from 'react-redux';
import { RaffleGroupForm } from './RaffleGroupForm';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class RaffleGroupDetail extends React.Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('raffle_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <div className="animate fadeIn">
        <RaffleGroupForm
          edit
          useCrop
          title="Raffle Group Details"
          {...this.props}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
  guardData: { isFetch, roles, isLogged, id, email }
})

const enhance = connect(mapStateToProps);

export default enhance(privateView(RaffleGroupDetail, ['supervisor', 'sale_supervisor', 'customer_service']));